









import { loadStripe } from "@stripe/stripe-js";
import { Component, Vue } from "vue-property-decorator";
@Component({
  metaInfo() {
    return {
      title:
        "Test Your Credit Card $0.99 - Not Sure If Your Credit Card Works?",
      meta: [
        {
          name: "description",
          content:
            "Easy way to test if your credit card works. Test if your credit card works.",
        },
      ],
    };
  },
})
export default class Login extends Vue {
  // onLogin() {
  //   axios.get(`${process.env.VUE_APP_API_URL}/api/auth/google`);
  // }
  async onBuy() {
    const stripe = await loadStripe(process.env.VUE_APP_PUB_STRIPE_KEY);
    // const {error} = await stripe?.redirectToCheckout({
    //   lineItems: [{
    //     price: process.env.price,
    //     quantity: 1
    //   }],
    //   successUrl: process.env.url,
    //   cancelUrl: process.env.url,
    // })
    await stripe?.redirectToCheckout({
      lineItems: [
        {
          price: process.env.VUE_APP_STRIPE_PRICE,
          quantity: 1,
        },
      ],
      mode: 'payment',
      successUrl: process.env.VUE_APP_SUCCESS,
      cancelUrl: process.env.VUE_APP_FAIL,
    });
  }
}
